import { EstimatedUnbillFigureEntity } from "domain/entity/EstimatedUnbillFigure/EstimatedUnbillFigureEntity";
import { INITIAL_ESTIMATED_UNBILL_FIGURE_COL_DEF } from "presentation/constant/EstimatedUnbillFigure/EstimatedUnbillFigureColumnDefinition";
import { EstimatedUnbillFigureConstant } from "presentation/constant/EstimatedUnbillFigure/EstimatedUnbillFigureConstant";
import { useEstimatedUnbillFigureVM } from "presentation/hook/EstimatedUnbillFigure/useEstimatedUnbillFigureVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useEstimatedUnbillFigureTracked } from "presentation/store/EstimatedUnbillFigure/EstimatedUnbillFigureProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef } from "react";
const EstimatedUnbillFigureTablePanel = () => {
    const gridRef: any = useRef(null);
    const [estimatedUnbillFigureState] = useEstimatedUnbillFigureTracked();
    const { tableList } = estimatedUnbillFigureState;
    const estimatedUnbillFigureVM = useEstimatedUnbillFigureVM();
    const ESTIMATED_UNBILL_FIGURE_CONSTANT = EstimatedUnbillFigureConstant.Title;
    const [anaInfoState] = useANAInfoTracked();
    const { allowCreate } = anaInfoState;

    const handleRowDoubleClick = useCallback((entity: EstimatedUnbillFigureEntity) => {
        estimatedUnbillFigureVM.onRowDoubleClick(entity);
    }, [estimatedUnbillFigureVM])

    const handleAdd = useCallback(() => {
        estimatedUnbillFigureVM.onAddClick();
    }, [estimatedUnbillFigureVM]);

    const memoEstimatedUnbillFigureTable = useMemo(() => {

        return (
            <NbisTable
                id='estimate-unbill-figure-table'
                isNewColumnSetting={true}
                headerLabel={ESTIMATED_UNBILL_FIGURE_CONSTANT.TITLE}
                columns={INITIAL_ESTIMATED_UNBILL_FIGURE_COL_DEF}
                data={tableList ?? []}
                showPaginator={false}
                editable={false}
                showAddIcon={allowCreate}
                onAddClick={handleAdd}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                isRowHighligted={true}
                onRowDoubleClick={(e: any, entity: EstimatedUnbillFigureEntity) => handleRowDoubleClick(entity)}
                gridHeight="customHeight"
                customHeight="calc(100vh - 75px)"
                ref={gridRef}
            />
        );
    }, [allowCreate, ESTIMATED_UNBILL_FIGURE_CONSTANT.TITLE, tableList, handleAdd, handleRowDoubleClick])

    return <><TableWrapper>
        {memoEstimatedUnbillFigureTable}
    </TableWrapper>
    </>;
}

export default memo(EstimatedUnbillFigureTablePanel);
